// extracted by mini-css-extract-plugin
module.exports = {"accordion__section":"bt_gx","accordion":"bt_gy","accordion__icon":"bt_gz","active":"bt_bH","accordion__title":"bt_gB","accordion__content":"bt_gC","accordion__text":"bt_gD"};